<template>
  <v-layout align-start v-resize="getDimensions">
    <v-row align="center" justify="center">
      <v-list-item-title align="center" class="text-h4 font-weight-black">
        INDICADORES DE PERSONAS Y CULTURA
      </v-list-item-title>
      <v-row>
        <v-col cols="12" sm="12" md="4">
          <v-autocomplete
            dense
            outlined
            ref="id_presupuesto"
            v-model="id_presupuesto"
            :items="presupuestos"
            @change="actualizarDashboard"
            :rules="[$rules.requerido]"
            :error-messages="errorMessages"
            item-text="descripcion"
            item-value="id"
            label="Presupuesto"
            required
          >
            <template v-slot:no-data> No hay información disponible </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-autocomplete
            dense
            outlined
            ref="mes"
            v-model="mes"
            :items="meses"
            :rules="[$rules.requerido]"
            @change="actualizarDashboard"
            :error-messages="errorMessages"
            item-text="descripcion"
            item-value="id"
            label="Mes"
            required
          >
            <template v-slot:no-data> No hay información disponible </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" sm="12" md="4">
          <v-autocomplete
            dense
            outlined
            ref="anio"
            v-model="anio"
            :items="anios"
            :rules="[$rules.requerido]"
            :error-messages="errorMessages"
            @change="actualizarDashboard"
            label="Año"
            required
          >
            <template v-slot:no-data> No hay información disponible </template>
          </v-autocomplete>
        </v-col>
      </v-row>

      <v-sheet
        class="overflow-y-auto"
        :max-height="height - 170"
        :max-width="width"
      >
        <v-col cols="12" sm="12" md="12">
          <v-card class="mx-auto">
            <br />

            <v-card-text>
              <v-card-text>
                <v-row align="center" justify="center">
                  <v-col cols="6" sm="6" md="2">
                    <v-list-item
                      two-line
                      @click="
                        mostrarDetalles(
                          'ALTA',
                          '_',
                          '__',
                          'Detalle de altas para el periodo ' +
                            mes +
                            '-' +
                            anio +
                            ''
                        )
                      "
                    >
                      <v-list-item-content>
                        <v-list-item-title align="center" class="text-h5">
                          {{ cantAltas }}
                        </v-list-item-title>
                        <v-list-item-subtitle align="center">{{
                          "Altas"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="6" sm="6" md="2">
                    <v-list-item
                      two-line
                      @click="
                        mostrarDetalles(
                          'BAJA',
                          '_',
                          '__',
                          'Detalle de bajas para el periodo ' +
                            mes +
                            '-' +
                            anio +
                            ''
                        )
                      "
                    >
                      <v-list-item-content>
                        <v-list-item-title align="center" class="text-h5">
                          {{ cantBajas }}
                        </v-list-item-title>
                        <v-list-item-subtitle align="center">{{
                          "Bajas"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="12" sm="12" md="4">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title
                          align="center"
                          class="text-h2 font-weight-black primary--text"
                        >
                          {{ cantColaboradoresActuales }}
                        </v-list-item-title>
                        <v-list-item-subtitle align="center">{{
                          "Colaboradores"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                  <v-col cols="6" sm="6" md="2">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title align="center" class="text-h5">
                          {{ rotVoluntario }} %
                        </v-list-item-title>
                        <v-list-item-subtitle align="center">{{
                          "Rotación de "
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle align="center">{{
                          "Retiro Voluntario"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="6" sm="6" md="2">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title align="center" class="text-h5">
                          {{ rotForzoso }} %
                        </v-list-item-title>
                        <v-list-item-subtitle align="center">{{
                          "Rotación de "
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle align="center">{{
                          "Retiro Forzoso"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>
              <v-row align="center" justify="center">
                <v-col cols="6" sm="6" md="2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title align="center" class="text-h5">
                        {{ cantBabyBoomers }}
                      </v-list-item-title>
                      <v-list-item-subtitle align="center">{{
                        "Baby Boomer"
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle align="center">{{
                        "1949 - 1968"
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6" sm="6" md="2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title align="center" class="text-h5">
                        {{ cantGeneracionX }}
                      </v-list-item-title>
                      <v-list-item-subtitle align="center">{{
                        "generación X"
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle align="center">{{
                        "1969 - 1980"
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>

                <v-col cols="12" sm="12" md="4">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title
                        align="center"
                        class="text-h3 font-weight-black primary--text"
                      >
                        {{ edadPromedio }}
                      </v-list-item-title>
                      <v-list-item-subtitle align="center">{{
                        "Edad"
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle align="center">{{
                        "Promedio"
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>

                <v-col cols="6" sm="6" md="2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title align="center" class="text-h5">
                        {{ cantMilenials }}
                      </v-list-item-title>
                      <v-list-item-subtitle align="center">{{
                        "Milenials"
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle align="center">{{
                        "1981 - 1993"
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>

                <v-col cols="6" sm="6" md="2">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <v-list-item-title align="center" class="text-h5">
                        {{ cantGeneracionZ }}
                      </v-list-item-title>
                      <v-list-item-subtitle align="center">{{
                        "Generación Z"
                      }}</v-list-item-subtitle>
                      <v-list-item-subtitle align="center">{{
                        "1993 - 2010"
                      }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-list-item-title
                  align="center"
                  class="text-h6 font-weight-black"
                >
                  Género
                </v-list-item-title>
                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h2" cols="6">
                      <v-list-item
                        two-line
                        @click="
                          mostrarDetalles(
                            'GENERO',
                            'Masculino',
                            '__',
                            'Detalles de Género: Masculino'
                          )
                        "
                      >
                        <v-list-item-content>
                          <v-list-item-title align="center" class="text-h4">
                            <v-icon x-large color="blue darken-2">
                              male
                            </v-icon>
                          </v-list-item-title>
                          <v-list-item-title align="center" class="text-h4">
                            {{ cantMasculino }}
                          </v-list-item-title>
                          <v-list-item-subtitle align="center">{{
                            "Masculino"
                          }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                    <v-col class="text-h2" cols="6">
                      <v-list-item
                        two-line
                        @click="
                          mostrarDetalles(
                            'GENERO',
                            'femenino',
                            '__',
                            'Detalles de Género: Femenino'
                          )
                        "
                      >
                        <v-list-item-content>
                          <v-list-item-title align="center" class="text-h4">
                            <v-icon x-large color="pink darken-2">
                              female
                            </v-icon>
                          </v-list-item-title>
                          <v-list-item-title align="center" class="text-h4">
                            {{ cantFemenino }}
                          </v-list-item-title>
                          <v-list-item-subtitle align="center">{{
                            "Femenino"
                          }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <apexchart
                  :options="optionsProfesiones"
                  :series="profesiones"
                ></apexchart>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <apexchart
                  :options="optionsAntiguedades"
                  :series="antiguedades"
                ></apexchart>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <apexchart
                  :options="optionsEdades"
                  :series="edades"
                ></apexchart>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <v-card class="mx-auto">
            <br />
            <v-list-item-title align="center" class="text-h4 font-weight-black">
              EVOLUCIÓN DE LA NÓMINA
            </v-list-item-title>

            <v-row>
              <v-col cols="12" sm="6" md="6">
                <apexchart
                  width="500"
                  :options="optionsAreas"
                  :series="areas"
                ></apexchart>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <apexchart
                  width="500"
                  :options="optionsCumplimientos"
                  :series="cumplimientos"
                ></apexchart>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <apexchart
                  width="500"
                  :options="optionsAltasBajas"
                  :series="altasBajas"
                ></apexchart>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <apexchart
                  width="500"
                  :options="optionsHeadcounts"
                  :series="headcounts"
                ></apexchart>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-row>
          <v-col></v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-card class="mx-auto">
              <br />
              <v-list-item-title
                align="center"
                class="text-h4 font-weight-black"
              >
                ALTAS
              </v-list-item-title>

              <v-card-text>
                <v-divider></v-divider>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="3">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title
                          align="center"
                          class="text-h2 font-weight-black primary--text"
                        >
                          {{ cantAltasTotal }}
                        </v-list-item-title>
                        <v-list-item-subtitle align="center">{{
                          "Altas"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" sm="12" md="9">
                    <apexchart
                      :options="optionsAltasTipo"
                      :series="altasTipos"
                    ></apexchart>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <apexchart
                    :options="optionsAltasArea"
                    :series="altasAreas"
                  ></apexchart>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <apexchart
                    :options="optionsAltasGenero"
                    :series="altasGeneros"
                  ></apexchart>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <v-col cols="12" sm="6" md="6">
            <v-card class="mx-auto">
              <br />
              <v-list-item-title
                align="center"
                class="text-h4 font-weight-black"
              >
                BAJAS
              </v-list-item-title>

              <v-card-text>
                <v-divider></v-divider>
                <v-row align="center" justify="center">
                  <v-col cols="12" sm="12" md="3">
                    <v-list-item two-line>
                      <v-list-item-content>
                        <v-list-item-title
                          align="center"
                          class="text-h2 font-weight-black primary--text"
                        >
                          {{ cantBajasTotal }}
                        </v-list-item-title>
                        <v-list-item-subtitle align="center">{{
                          "Bajas"
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>

                  <v-col cols="12" sm="12" md="9">
                    <apexchart
                      :options="optionsBajasTipo"
                      :series="bajasTipos"
                    ></apexchart>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-divider></v-divider>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <apexchart
                    :options="optionsBajasArea"
                    :series="bajasAreas"
                  ></apexchart>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <apexchart
                    :options="optionsBajasGenero"
                    :series="bajasGeneros"
                  ></apexchart>
                  <div></div>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
        <v-dialog v-model="dialogDetalle" max-width="950px">
          <v-card ref="form">
            <v-app-bar color="white" elevate-on-scroll flat>
              <span class="primary--text font-weight-bold"
                >{{ descripcionDetalle }}
              </span>

              <v-spacer></v-spacer>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    @click="dialogDetalle = false"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    fab
                  >
                    <v-icon dark> close </v-icon>
                  </v-btn>
                </template>
                <span>Volver</span>
              </v-tooltip>
            </v-app-bar>

            <v-card-text>
              <v-card class="overflow-hidden">
                <v-sheet class="overflow-y-auto" :max-height="height + 110">
                  <v-data-table
                    dense
                    fixed-header
                    :height="height - 240"
                    :headers="headersDetalle"
                    :items="dtDetalle"
                    :items-per-page="2"
                    class="elevation-1"
                    :header-props="{
                      'sort-icon': 'fa-solid fa-arrow-down-wide-short',
                    }"
                    :footer-props="{
                      'items-per-page-text': 'Filas por página',
                      'items-per-page-options': [-1, 100, 150, 200],
                    }"
                  >
                    <template v-slot:[`item.fecha_nac`]="{ item }">
                      {{ $formatoFechaSpanish(item.fecha_nac) }}
                    </template>
                    <template v-slot:[`item.fecha_ingreso`]="{ item }">
                      {{ $formatoFechaSpanish(item.fecha_ingreso) }}
                    </template>
                    <template v-slot:[`item.fecha_salida`]="{ item }">
                      {{ $formatoFechaSpanish(item.fecha_salida) }}
                    </template>

                    <template v-slot:no-data>
                      <span>No se encontraron registros</span>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-sheet>
    </v-row>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      width: 0,
      height: 0,

      dialogDetalle: false,
      descripcionDetalle: "",
      dtDetalle: [],
      id_presupuesto: "2",
      mes: (new Date().getMonth() + 1).toString(),
      anio: new Date().getFullYear().toString(),
      presupuestos: [],
      errorMessages: "",
      rotVoluntario: 0.0,
      rotForzoso: 0.0,

      cantBabyBoomers: 0,
      cantMilenials: 0,
      cantGeneracionX: 0,
      cantGeneracionZ: 0,
      cantMasculino: 0,
      cantFemenino: 0,
      edadPromedio: 0,
      cantAltas: 0,
      cantBajas: 0,
      cantAltasTotal: 0,
      cantBajasTotal: 0,
      cantColaboradoresActuales: 0,
      profesiones: [],
      profesionesCabecera: [],
      antiguedades: [],
      edades: [],
      areas: [],
      cumplimientos: [],
      altasBajas: [],

      altasGeneros: [],
      bajasGeneros: [],

      altasTipos: [],
      bajasTipos: [],

      altasAreas: [],
      bajasAreas: [],

      headersDetalle: [
        {
          text: "Cod",
          value: "codigo",
          class: "primary white--text text-subtitle-2",
          width: "1%",
        },

        {
          text: "Nombre",
          value: "nombre_completo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Cargo",
          value: "cargo",
          class: "primary white--text text-subtitle-2",
        },
        {
          text: "Ciudad",
          value: "ciudad",
          class: "primary white--text text-subtitle-2",
          width: "10%",
        },
        {
          text: "Fecha de nacimiento",
          value: "fecha_nac",
          class: "primary white--text text-subtitle-2",
          width: "10%",
        },
        {
          text: "Fecha de ingreso",
          value: "fecha_ingreso",
          class: "primary white--text text-subtitle-2",
          width: "10%",
        },
        {
          text: "Fecha de Retiro",
          value: "fecha_salida",
          class: "primary white--text text-subtitle-2",
          width: "10%",
        },
      ],

      anios: [],

      meses: [
        { id: "1", descripcion: "Enero" },
        { id: "2", descripcion: "Febrero" },
        { id: "3", descripcion: "Marzo" },
        { id: "4", descripcion: "Abril" },
        { id: "5", descripcion: "Mayo" },
        { id: "6", descripcion: "Junio" },
        { id: "7", descripcion: "Julio" },
        { id: "8", descripcion: "Agosto" },
        { id: "9", descripcion: "Septiembre" },
        { id: "10", descripcion: "Octubre" },
        { id: "11", descripcion: "Noviembre" },
        { id: "12", descripcion: "Diciembre" },
      ],

      headcounts: [],
      series: [],
      titulos: [],
      datos: [],
      data: [
        [
          "Profesion",
          "Cantidad",
          "{ role: 'style' }",
          "{ role: 'annotation' }",
        ],
        ["Licenciatura", 11, "green", 25],
        ["Maestria", 2, "green", 25],
        ["Bachillerato", 2, "green", 25],
        ["Doctorado", 2, "green", 25],
      ],

      dataAntig: [
        [
          "Profesion",
          "Cantidad",
          "Cantidad_2",
          { role: "style" },
          { role: "annotation" },
          { role: "annotation" },
        ],
        [">15", 25, 30, "green", 25, 30],
        ["11 a 15", 8, 25, "red", 8, 25],
        ["6 a 10", 35, 20, "blue", 35, 20],
        ["3 a 5", 51, 40, "yellow", 51, 40],
        ["<=2", 129, 200, "orange", 129, 200],
      ],

      options: {
        title: "",
        pieHole: 0.1,
        width: 400,
        height: 300,
      },
      optionsProfesiones: {
        chart: {
          type: "donut",
          width: "100%",
        },
        title: {
          text: "Formación Académica",
        },
        labels: [],

        legend: {
          show: true,
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
                position: "bottom",
              },
            },
          },
        ],
      },
      optionsAltasGenero: {
        chart: {
          type: "donut",
          width: "100%",
        },
        title: {
          text: "Altas por Género",
        },
        labels: [],
        colors: ["#ff4560", "#008ffb"],

        legend: {
          show: true,
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
                position: "bottom",
              },
            },
          },
        ],
      },
      optionsBajasGenero: {
        chart: {
          type: "donut",
          width: "100%",
        },
        title: {
          text: "Bajas por Género",
        },
        labels: [],
        colors: ["#ff4560", "#008ffb"],
        legend: {
          show: true,
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
                position: "bottom",
              },
            },
          },
        ],
      },

      optionsAltasTipo: {
        chart: {
          type: "donut",
          width: "100%",
        },
        title: {
          text: "Altas por Tipo",
        },
        labels: [],

        legend: {
          show: true,
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
                position: "bottom",
              },
            },
          },
        ],
      },

      optionsBajasTipo: {
        chart: {
          type: "donut",
          width: "100%",
        },
        title: {
          text: "Bajas por Tipo",
        },
        labels: [],

        legend: {
          show: true,
          position: "bottom",
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
                position: "bottom",
              },
            },
          },
        ],
      },

      optionsAreas: {
        chart: {
          type: "bar",
          width: "100%",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: [
          "#00E396",
          "#008FFB",
          "#FEB019",
          "#FF4560",
          "#775DD0",
          "#546E7A",
          "#26a69a",
          "#D10CE8",
        ],
        title: {
          text: "Colaboradores por Área",
        },
        dataLabels: {
          enabled: true,
          offsetX: 20,
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [1],
        },
      },

      optionsAntiguedades: {
        chart: {
          type: "bar",
          width: "100%",
        },
        title: {
          text: "Antigüedad",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: ["#00E396"],
        dataLabels: {
          enabled: true,
          offsetX: 20,
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [1],
        },
      },
      optionsCumplimientos: {
        chart: {
          type: "bar",
          width: "100%",
        },
        title: {
          text: "Cumplimiento de Presupuesto por Area Corporativa",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: ["#00E396"],
        dataLabels: {
          enabled: true,
          offsetX: 30,
          formatter: function (val) {
            return val + "%";
          },
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        yaxis: {
          axisBorder: {
            show: true,
          },
          axisTicks: {
            show: true,
          },
          labels: {
            show: true,
            //formatter: function (val) {
            //  return val + "%";
            //},
          },
        },
        xaxis: {
          categories: [1],
        },
      },

      optionsAltasArea: {
        chart: {
          type: "bar",
          width: "100%",
        },
        title: {
          text: "Altas por Área",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: ["#00E396"],
        dataLabels: {
          enabled: true,
          offsetX: 20,
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [1],
        },
      },

      optionsBajasArea: {
        chart: {
          type: "bar",
          width: "100%",
        },
        title: {
          text: "Bajas por Área",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: ["#feb019"],
        dataLabels: {
          enabled: true,
          offsetX: 20,
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [1],
        },
      },

      optionsEdades: {
        chart: {
          type: "bar",
          width: "100%",
        },

        title: {
          text: "Edades",
        },
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: "top",
            },
          },
        },

        dataLabels: {
          enabled: true,
          offsetX: 20,
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [1],
        },
      },
      optionsAltasBajas: {
        chart: {
          type: "bar",
          width: "100%",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: [
          "#00E396",
          "#008FFB",
          "#FEB019",
          "#FF4560",
          "#775DD0",
          "#546E7A",
          "#26a69a",
          "#D10CE8",
        ],
        title: {
          text: "Altas & Bajas",
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [1],
        },
      },

      optionsHeadcounts: {
        chart: {
          type: "bar",
          width: "100%",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
            },
          },
        },
        colors: [
          "#00E396",
          "#008FFB",
          "#FEB019",
          "#FF4560",
          "#775DD0",
          "#546E7A",
          "#26a69a",
          "#D10CE8",
        ],
        title: {
          text: "Headcount",
        },
        dataLabels: {
          enabled: true,
          offsetY: -20,
          style: {
            fontSize: "12px",
            colors: ["#000"],
          },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          categories: [1],
        },
      },
    };
  },
  created() {
    this.generarGestiones();
    this.selectPresupuesto();

    this.actualizarDashboard();
  },
  mounted() {
    this.getDimensions();
  },
  methods: {
    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    actualizarDashboard() {
      this.contarBabyBoomers();
      this.contarMilenials();
      this.contarGeneracionX();
      this.contarGeneracionZ();
      this.obtenerEdadPromedio();

      this.contarMasculino();
      this.contarFemenino();

      this.obtenerProfesiones();

      this.obtenerAntiguedades();
      this.obtenerEdades();

      this.contarAltas();
      this.contarBajas();
      this.contarColaboradoresActuales();
      this.obtenerAreas();

      this.obtenerCumplimiento();
      this.obtenerAltasBajas();
      this.obtenerHeadcounts();
      this.contarBajasTotal();
      this.contarAltasTotal();
      this.obtenerAltasGenero();
      this.obtenerBajasGenero();
      this.obtenerAltasArea();
      this.obtenerBajasArea();
      this.obtenerAltasTipo();
      this.obtenerBajasTipo();
      this.contarRotacionForzoso();
      this.contarRotacionVoluntario();
    },

    contarColaboradoresActuales() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/COLABACTUAL/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantColaboradoresActuales = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },
    contarRotacionForzoso() {
      let me = this;
      axios
        .get(
          "api/tableros/monto/ROTACION_FORZOSO/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.rotForzoso = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },
    contarRotacionVoluntario() {
      let me = this;
      axios
        .get(
          "api/tableros/monto/ROTACION_VOLUNTARIO/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.rotVoluntario = response.data;
          console.log(response.data);
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarAltas() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/ALTA/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantAltas = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarBajas() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/BAJA/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantBajas = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarBabyBoomers() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/BOOMER/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantBabyBoomers = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarMilenials() {
      let me = this;
      axios

        .get(
          "api/tableros/contar/MILENIAL/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantMilenials = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarGeneracionX() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/GENX/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantGeneracionX = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarGeneracionZ() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/GENZ/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantGeneracionZ = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarMasculino() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/MASCULINO/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantMasculino = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarFemenino() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/FEMENINO/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantFemenino = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerEdadPromedio() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/EDAD/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.edadPromedio = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarAltasTotal() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/ALTA_TOTAL/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantAltasTotal = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    contarBajasTotal() {
      let me = this;
      axios
        .get(
          "api/tableros/contar/BAJA_TOTAL/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.cantBajasTotal = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    listarDetalle(tipo, criterio, criterio2) {
      let me = this;
      me.dtDetalle = [];
      axios
        .get(
          "api/tableros/detalleChart/" +
            tipo +
            "/" +
            criterio +
            "/" +
            criterio2 +
            "/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.dtDetalle = response.data;
          //get data for apexcharts
          //**var titulosInt = Object.keys(me.datos[0]);
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },
    mostrarDetalles(tipo, criterio, criterio2, detalle) {
      let me = this;
      me.listarDetalle(tipo, criterio, criterio2);
      me.descripcionDetalle = detalle;
      me.dialogDetalle = true;
    },

    obtenerAreas() {
      let me = this;

      axios
        .get(
          "api/tableros/genericChart/AREA_MULTIPLE/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );

          var datos2 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[2]]
          );

          me.areas = [
            {
              name: "Actual",
              data: datos1,
            },
            {
              name: "Presupuestado",
              data: datos2,
            },
          ];

          me.optionsAreas = {
            ...me.optionsAreas,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];
                    var criterio2 = me.areas[config.seriesIndex].name;
                    me.mostrarDetalles(
                      "AREA_MULTIPLE",
                      criterio,
                      criterio2,
                      "Colaboradores - " +
                        criterio2 +
                        " para el área: " +
                        criterio
                    );
                  },
                },
                type: "bar",
                width: "100%",
              },

              xaxis: {
                categories: cabeceras,
              },
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerAltasBajas() {
      let me = this;

      axios
        .get(
          "api/tableros/GenericChart/ALTAS_BAJAS/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );

          var datos2 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[2]]
          );

          me.altasBajas = [
            {
              name: "Altas",
              data: datos1,
            },
            {
              name: "Bajas",
              data: datos2,
            },
          ];

          me.optionsAltasBajas = {
            ...me.optionsAltasBajas,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];
                    var criterio2 = me.altasBajas[config.seriesIndex].name;
                    console.log();
                    me.mostrarDetalles(
                      "ALTAS_BAJAS",
                      criterio,
                      criterio2,
                      "" + criterio2 + " para el mes de : " + criterio
                    );
                  },
                },
                type: "bar",
                width: "100%",
              },
              xaxis: {
                categories: cabeceras,
              },
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerHeadcounts() {
      let me = this;
      axios
        .get(
          "api/tableros/genericChart/HEADCOUNT/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );

          var datos2 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[2]]
          );

          me.headcounts = [
            {
              name: "Actual",
              data: datos1,
            },
          ];

          me.optionsHeadcounts = {
            ...me.optionsHeadcounts,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];

                    me.mostrarDetalles(
                      "HEADCOUNT",
                      criterio,
                      "__",
                      "HEADCOUNT " + criterio
                    );
                  },
                },
                type: "bar",
                width: "100%",
              },
              xaxis: {
                categories: cabeceras,
              },
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerProfesiones() {
      let me = this;
      axios
        .get(
          "api/tableros/genericChart/PROFESION/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          //**var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item["nombre"]
          );

          me.profesiones = me.datos.map(
            (
              item //get series
            ) => item["cantidad_1"]
          );

          me.optionsProfesiones = {
            ...me.optionsProfesiones,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var formacion = cabeceras[config.dataPointIndex];
                    me.mostrarDetalles(
                      "PROFESION",
                      formacion,
                      "__",
                      "Formación Académica: " + formacion
                    );
                  },
                },
              },
              labels: cabeceras,
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerAltasTipo() {
      let me = this;
      axios
        .get(
          "api/tableros/genericChart/ALTA_AREA/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;

          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );
          console.log(cabeceras);
          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );
          console.log(datos1);
          me.altasTipos = datos1;

          me.optionsAltasTipo = {
            ...me.optionsAltasTipo,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];

                    me.mostrarDetalles(
                      "ALTA_AREA",
                      criterio,
                      "__",
                      "Altas por área:  " + criterio
                    );
                  },
                },
              },

              labels: cabeceras,
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerBajasTipo() {
      let me = this;
      axios
        .get(
          "api/tableros/GenericChart/TIPO_BAJA/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );
          console.log(datos1);
          me.bajasTipos = datos1;

          me.optionsBajasTipo = {
            ...me.optionsBajasTipo,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];
                    me.mostrarDetalles(
                      "TIPO_BAJA",
                      criterio,
                      "__",
                      "Tipo de Baja: " + criterio
                    );
                  },
                },
              },
              labels: cabeceras,
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerAltasGenero() {
      let me = this;
      axios
        .get(
          "api/tableros/genericChart/ALTA_GENERO/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );
          console.log(datos1);
          me.altasGeneros = datos1;

          me.optionsAltasGenero = {
            ...me.optionsAltasGenero,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];
                    me.mostrarDetalles(
                      "ALTA_GENERO",
                      criterio,
                      "__",
                      "Altas: " + criterio
                    );
                  },
                },
              },
              labels: cabeceras,
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerBajasGenero() {
      let me = this;
      axios
        .get(
          "api/tableros/genericChart/BAJA_GENERO/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );
          console.log(datos1);
          me.bajasGeneros = datos1;

          me.optionsBajasGenero = {
            ...me.optionsBajasGenero,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];
                    me.mostrarDetalles(
                      "BAJA_GENERO",
                      criterio,
                      "__",
                      "Bajas: " + criterio
                    );
                  },
                },
              },
              labels: cabeceras,
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerAltasArea() {
      let me = this;
      axios
        .get(
          "api/tableros/GenericChart/ALTA_AREA/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );

          me.altasAreas = [
            {
              name: "Total",
              data: datos1,
            },
          ];

          me.optionsAltasArea = {
            ...me.optionsAltasArea,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];

                    me.mostrarDetalles(
                      "ALTA_AREA",
                      criterio,
                      "__",
                      "Altas por área:  " + criterio
                    );
                  },
                },
                type: "bar",
                width: "100%",
              },
              xaxis: {
                categories: cabeceras,
              },
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerBajasArea() {
      let me = this;
      axios
        .get(
          "api/tableros/GenericChart/BAJA_AREA/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );

          me.bajasAreas = [
            {
              name: "Total",
              data: datos1,
            },
          ];

          me.optionsBajasArea = {
            ...me.optionsBajasArea,
            ...{
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];

                    me.mostrarDetalles(
                      "BAJA_AREA",
                      criterio,
                      "__",
                      "Bajas por área:  " + criterio
                    );
                  },
                },
                type: "bar",
                width: "100%",
              },
              xaxis: {
                categories: cabeceras,
              },
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerAntiguedades() {
      let me = this;
      axios
        .get(
          "api/tableros/genericChart/ANTIGUEDAD/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );

          me.antiguedades = [
            {
              name: "Cantidad",
              data: datos1,
            },
          ];

          me.optionsAntiguedades = {
            ...me.optionsAntiguedades,
            ...{
              xaxis: {
                categories: cabeceras,
              },
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];
                    me.mostrarDetalles(
                      "ANTIGUEDAD",
                      criterio,
                      "__",
                      "Rango de antigüedad: " + criterio
                    );
                  },
                },
              },
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerEdades() {
      let me = this;
      axios
        .get(
          "api/tableros/genericChart/EDAD/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );

          me.edades = [
            {
              name: "Cantidad",
              data: datos1,
            },
          ];

          me.optionsEdades = {
            ...me.optionsEdades,
            ...{
              xaxis: {
                categories: cabeceras,
              },
              chart: {
                events: {
                  dataPointSelection(event, chartContext, config) {
                    var criterio = cabeceras[config.dataPointIndex];
                    me.mostrarDetalles(
                      "EDAD",
                      criterio,
                      "__",
                      "Rango de Edad: " + criterio
                    );
                  },
                },
              },
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },

    obtenerCumplimiento() {
      let me = this;
      axios
        .get(
          "api/tableros/GenericChart/CUMPLIMIENTO/" +
            me.anio +
            "/" +
            me.mes +
            "/" +
            me.id_presupuesto +
            ""
        )
        .then(function (response) {
          me.datos = response.data;
          //get data for apexcharts
          var titulosInt = Object.keys(me.datos[0]);

          var cabeceras = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[0]]
          );

          var datos1 = me.datos.map(
            (
              item //get series
            ) => item[titulosInt[1]]
          );

          me.cumplimientos = [
            {
              name: "Cumplimiento",
              data: datos1,
            },
          ];

          me.optionsCumplimientos = {
            ...me.optionsCumplimientos,
            ...{
              xaxis: {
                categories: cabeceras,
              },
            },
          };
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error" + error,
            color: "error",
          });
        });
    },
    generarGestiones() {
      let me = this;
      var anioActual = new Date().getUTCFullYear();
      anioActual -= 3;

      for (var i = 0; i < 5; i++) {
        const dato = anioActual.toString();
        this.anios.push(dato);
        anioActual += 1;
      }
    },

    selectPresupuesto() {
      let me = this;
      axios
        .get("api/presupuestos/select")
        .then(function (response) {
          me.presupuestos = response.data;
          me.id_presupuesto = 2;
          //me.id_presupuesto=me.presupuestos[0].id;
          //me.id_presupuesto=response.data[0].id;
          //me.listar();
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : "error",
            color: "error",
          });
        });
    },
  },
};
</script>
